export default __webpack_public_path__ + "static/media/twitter-blue.37c9abeb.svg";